import { XpressDisciplinaryStatus } from 'app/models';

export class XpressDisciplinaryStatusModel {
    public static XpressDisciplinaryStatusList: Array<any> = [
        { name: 'New', value: XpressDisciplinaryStatus.New },
        { name: 'Pending', value: XpressDisciplinaryStatus.Pending },
        { name: 'Hearing', value: XpressDisciplinaryStatus.Hearing },
        { name: 'Investigating', value: XpressDisciplinaryStatus.Investigating },
        { name: 'Meeting', value: XpressDisciplinaryStatus.Meeting },
        { name: 'Cleared', value: XpressDisciplinaryStatus.Cleared },
        { name: 'Banned', value: XpressDisciplinaryStatus.Banned },
        { name: 'Closed', value: XpressDisciplinaryStatus.Closed },
        { name: 'Suspension', value: XpressDisciplinaryStatus.Suspension }
    ];
}
